import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import useLocalStorage from '../../../helpers/useLocalstorage';

export const Context = createContext({});

const schema = yup.object().shape({});

export const Provider = ({ resetClient, children }) => {
  const [fields, setFields] = useState({});
  const [validationError, setValidationError] = useState([]);
  const [authorized, setAuthorized] = useState(undefined);

  const [token, setToken] = useLocalStorage('token', {});
  const [expire, setExpire] = useLocalStorage('expire', {});
  const [refresh, setRefreshToken] = useLocalStorage('refreshToken', {});

  // ====================================
  // Authorize

  const updateVpnData = (data, vpn) => {
    const {
      accessToken,
      accessUnixExpiration,
      refreshToken,
    } = data;

    const newTokens = token;
    newTokens[vpn] = accessToken;
    setToken(newTokens);

    const newExp = expire;
    newExp[vpn] = accessUnixExpiration;
    setExpire(newExp);

    const newRefToken = refresh;
    newRefToken[vpn] = refreshToken;
    setRefreshToken(newRefToken);
  };

  const setAuth = (data, vpn) => {
    const newToken = data && data.accessToken;
    if (newToken) {
      updateVpnData(data, vpn);
      resetClient(newToken);
      setAuthorized(true);
    } else if (token[vpn] && token[vpn] !== '') {
      resetClient(token[vpn]);
      setAuthorized(true);
    } else {
      resetClient();
      setAuthorized(false);
    }
  };

  // ====================================
  // Validation

  const handleFormValidation = (formFields) => {
    schema.validate(formFields, { abortEarly: false }).then(
      () => {
        setValidationError([]);
      },
      (response) => {
        setValidationError(response.inner);
      },
    );
  };

  useEffect(() => {
    handleFormValidation({ ...fields });
  }, [fields]);

  // ====================================
  // General Actions

  const handleUpdateValue = (name, value) => {
    setFields({ ...fields, [name]: value });
  };

  const handleUpdateFields = () => {
    // TODO: save to db
  };

  const contextData = {
    formData: fields,
    setField: handleUpdateValue,
    setFormData: setFields,
    saveData: handleUpdateFields,
    formErrors: validationError,
    authorize: setAuth,
    isAuthorized: authorized,
  };

  return <Context.Provider value={contextData}>{children}</Context.Provider>;
};

export const { Consumer } = Context;

Provider.propTypes = {
  resetClient: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
